module.exports = __webpack_public_path__ + "9983ccc85e1ffa3b1ef58c6156c8abe9.jpg";